import { aliasUser, identifyUser } from '../../lib/analytics';
import { getAttributionData, getMarketingAnonId } from '../../lib/attribution';
import Auth from '../../lib/Auth';

interface Props {
  id: number;
  email: string;
  userHash: string;
}

// once the API has set the session cookies: switches the app to signed in and identifies the user
export function completeLogin({ id, email, userHash }: Props) {
  Auth.saveTokenData();

  const marketingAnonId = getMarketingAnonId();
  if (marketingAnonId && window.rudderanalytics?.setAnonymousId) {
    window.rudderanalytics.setAnonymousId(marketingAnonId);
  }

  aliasUser(String(id), email);
  identifyUser(String(id), { email, ...getAttributionData() }, { intercomUserHash: userHash });
}
